import { m, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const reduce = useReducedMotion();
  const C = m[as];
  return (
    <C
      {...rest}
      className={className}
      initial={reduce ? false : { y: 8 }}
      whileInView={{ y: 0 }}
      viewport={{ once: true, amount: 0.01, margin: "0px 0px 240px 0px" }}
      transition={{ duration: 0.2, delay: 0, ease: "easeOut" }}
    >
      {children}
    </C>
  );
};

export const SectionHead = ({ eyebrow, title, accent, text, id, center = false, light = false }) => (
  <Reveal className={`max-w-3xl mb-8 md:mb-10 ${center ? "mx-auto text-center" : ""}`}>
    <p className={`eyebrow mb-3 ${light ? "!text-white/70" : ""}`} data-testid={`${id}-eyebrow`}>{eyebrow}</p>
    <h2 data-testid={`${id}-heading`} className={`h-display text-2xl sm:text-3xl lg:text-4xl ${light ? "text-white" : ""}`}>
      {title} {accent && <span className={light ? "text-[#E9B3EE]" : "accent"}>{accent}</span>}
    </h2>
    {text && <p data-testid={`${id}-description`} className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-white/75" : "muted"}`}>{text}</p>}
  </Reveal>
);
